<select
  class="form-select"
  [ngClass]="props.selectClass"
  [class.is-invalid]="showError"
  [formControl]="$any(formControl)"
  [formlyAttributes]="field"
  [class.disabled]="!!props.disabled"
  [class.readonly]="!!props.readonly"
  [attr.data-testid]="props.testId"
  [attr.tabindex]="!!props.readonly ? -1 : 0"
>
  <option
    [hidden]="!showPlaceholder"
    [ngValue]="null"
  >
    {{ props.placeholder }}
  </option>

  @for (option of optionsArray; track $index) {
    <option
      [ngValue]="option.value"
      [disabled]="!!option.disabled"
      [attr.data-testid]="props.testId + '_option_' + option.value"
    >
      {{ option.label }}
    </option>
  }
</select>
